import React from "react";
import "../simple_editor/simple_editor.css";

const RequestRenderer = (params) => {
  return <div>REQ_{params.value.toString().padStart(8, "0")}</div>;
};

export default RequestRenderer;
